import {
    GET_LOGIN_AUDIT,
    GET_FILTROS_LOGIN_AUDIT,
    GET_DETALLE_LOGIN_AUDIT
} from "../action"

const initialState = {
    data: [],
    total: 0,
    params: {},
    filtros: {},
    selectedRegistro: null
}

const loginAudit = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGIN_AUDIT:
            return {
                ...state,
                data: action.data,
                total: action.total || 0,
                params: action.params
            }
        case GET_FILTROS_LOGIN_AUDIT:
            return {
                ...state,
                filtros: action.filtros
            }
        case GET_DETALLE_LOGIN_AUDIT:
            return {
                ...state,
                selectedRegistro: action.selectedRegistro
            }
        default:
            return { ...state }
    }
}

export default loginAudit
